'use strict';
module.exports = require('./TabView.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/tabview/index.js
// module id = 419
// module chunks = 7